module.exports = __webpack_public_path__ + "assets/circle-ellipsis-solid.81e942ff.svg";